import { DownloadQuestionnaireStatPayload } from 'reducers/dashboard/issues/questionnaireStat/types';
import { getToken } from 'reducers/api';
import serializeQuery from '../../../../helpers/serializeQuery';
import { apiURL } from 'config/baseURL';
import { gatewayFetch } from '../../../../helpers/gateway';

export interface DownloadQuestionnaireStatResponse {
	message: 'SUCCESS';
	url: string;
}
interface ErrorResponse {
	message: 'FAILED';
}

export const downloadQuestionnaireStat = async (
	query: DownloadQuestionnaireStatPayload,
): Promise<DownloadQuestionnaireStatResponse | ErrorResponse> => {
	try {
		const token = await getToken();
		const options: RequestInit = {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: token,
			},
		};
		const serializedQueries = serializeQuery(query);
		const url = `${apiURL}/statistics/issues/questionnaires?${serializedQueries}`;
		const res = await gatewayFetch(url, options);

		if (res.status !== 200) {
			throw new Error('');
		}
		const blob = await res.blob();
		const blobURL = window.URL.createObjectURL(blob);

		const downloadURLResult: DownloadQuestionnaireStatResponse = {
			message: 'SUCCESS',
			url: blobURL,
		};
		return downloadURLResult;
	} catch {
		const errorResult: ErrorResponse = {
			message: 'FAILED',
		};
		return errorResult;
	}
};
